import React from 'react'
import { Div, H6, Section } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const IntelItem = ({ displayName, value }) => {
  return (
    <Div className="contact-details--attributes-card-field">
      <span className="field-key">{displayName}</span>
      <span className="field-value" data-private>{value}</span>
    </Div>
  )
}

const DriftIntelCard = ({ intelData, groupName }) => {
  return (
    <Div className="contact-details--attributes-card">
      <Div className="contact-details--attributes-card-header">
        <Div className="contact-details--attributes-card-header-icon">
          <Icon name="drift-bolt" width="1rem" height="1rem"/>
        </Div>
        <Div className="contact-details--attributes-card-header-text">
          <H6>{groupName}</H6>
        </Div>
      </Div>
      <Section className="contact-details--attributes--properties-container">
        {Object.entries(intelData).map(([k, v]) => (
          <IntelItem displayName={k} value={v} key={v} />
        ))}
      </Section>
    </Div>
  )
}

export default DriftIntelCard
